import { render, staticRenderFns } from "./CoroEvolution.vue?vue&type=template&id=2be08ffc&scoped=true&"
import script from "./CoroEvolution.vue?vue&type=script&lang=ts&"
export * from "./CoroEvolution.vue?vue&type=script&lang=ts&"
import style0 from "./CoroEvolution.vue?vue&type=style&index=0&id=2be08ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be08ffc",
  null
  
)

export default component.exports